import { motion } from 'framer-motion';
import React, { FC, useEffect } from 'react';
import FormSuccessBlockTick from '../../atoms/form-success-block-tick/form-sucess-block-tick';

interface Props {
  readonly heading: string;
  readonly message?: string;
  readonly onRedirect?: () => void;
  readonly redirectSeconds?: number;
}

const FormSuccessBlock: FC<Props> = ({
  heading,
  message,
  onRedirect,
  redirectSeconds,
}: Props) => {
  useEffect(() => {
    if (redirectSeconds > 0) {
      setTimeout(() => {
        onRedirect();
      }, redirectSeconds * 1000);
    }
  });

  return (
    <div className="bg-light-blue p-8 rounded-lg">
      <div className="flex justify-center h-16">
        <FormSuccessBlockTick />
      </div>

      <div className="flex flex-col items-center mx-auto text-center max-w-md">
        <motion.h5
          animate={{ opacity: 1 }}
          className="page-heading-five mt-6"
          initial={{ opacity: 0 }}
        >
          {heading}
        </motion.h5>

        {message && (
          <motion.p
            animate={{ opacity: 1 }}
            className="mt-2 text-grey-600"
            initial={{ opacity: 0 }}
          >
            {message}
          </motion.p>
        )}
      </div>
    </div>
  );
};

FormSuccessBlock.defaultProps = {
  message: '',
  onRedirect: () => ({}),
  redirectSeconds: 0,
};

export default FormSuccessBlock;
